import React from "react";
import { Modal as AntModal, Image as AntImage } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { DefaultIMG } from "@assets";

export const FooterContainer = styled.div`
  height: 52px;
  display: flex;
  border-top: 2px solid #f4f1eb;
`;

export const CancelButton = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.dark1};
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OKButton = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.blackGradient};
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.golden};
  border-radius: 0 0 8px 0;
`;

export const Modal = styled(AntModal)`
  .ant-modal-content {
    margin: 0;
    padding: 10px 0 0 0;
  }
`;

const ModalTitle = styled.p`
  color: ${(props) => props.theme.primarySolid};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const Image = styled(AntImage).attrs({
  alt: "img",
  fallback: DefaultIMG,
  preview: false,
})`
  margin-bottom: 14px;
  width: 70px !important;
  object-fit: cover;
  aspect-ratio: 1;
  border-radius: 20px;
`;

const ExitConfirmModal = ({
  open,
  confirmLoading,
  gameIcon,
  onCancel,
  onOk,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      width={300}
      confirmLoading={confirmLoading}
      open={open}
      footer={
        <FooterContainer>
          <CancelButton onClick={onCancel}>{t("common.cancel")}</CancelButton>
          <OKButton onClick={onOk}>{t("common.ok")}</OKButton>
        </FooterContainer>
      }
    >
      <div style={{ textAlign: "center" }}>
        <Image src={gameIcon} />
        <ModalTitle>{t("maintain.exitGameConfirmMessage")}</ModalTitle>
      </div>
    </Modal>
  );
};

export default ExitConfirmModal;
